export default __webpack_public_path__ + "static/ipx-9c1bf12effc51e1e830b2471539bd8f1.png";